'use strict';

const $ = require('jquery');

module.exports = function() {

  const spinnerMethods = {
    start: function() {
      this.attr('disabled', 'disabled');
      this.addClass('slideshow-btn-disabled');
      this.prepend('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate js-spinner" style="margin-right: 10px;"></span>');
    },
    stop: function() {
      this.removeAttr('disabled');
      this.removeClass('slideshow-btn-disabled');
      this.find('.js-spinner').remove();
    }
  };

  // http://stackoverflow.com/a/6871820/1211073
  $.fn.spinner = function(method) {
    if (spinnerMethods[method])
      return spinnerMethods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    else if (typeof method === 'object' || !method)
      return spinnerMethods.start.apply(this, arguments);
    $.error( 'Method ' +  method + ' does not exist on jQuery.spinner' );
  };

};
